import { QueryClient, QueryKey } from '@tanstack/react-query';

// For a block's unmount cleanup: drops its cached data so a reopened report refetches (refetchOnMount is off),
// but keeps queries another mounted viewer of the same report still observes. Removing those would silently
// cancel their in-flight fetch and leave that viewer pending forever. Deferred so the unmounting
// block's own observers are already gone.
export default function removeUnobservedQueries(queryClient: QueryClient, queryKey: QueryKey) {
    setTimeout(() => {
        const cache = queryClient.getQueryCache();
        cache.findAll({ queryKey }).forEach((query) => {
            if (query.getObserversCount() == 0) {
                cache.remove(query);
            }
        });
    }, 0);
}
